import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

type ProductCardWhatsIncludedHeadingProps = ComponentProps<'h4'>;

/** The panel's one-line pitch, above the list. */
const ProductCardWhatsIncludedHeading = ({ className, children, ...props }: ProductCardWhatsIncludedHeadingProps) => (
  <h4
    className={cn(
      'preflight preflight-h4 max-w-[296px] text-center text-base/[19px] font-semibold text-green-900',
      className,
    )}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </h4>
);

export default ProductCardWhatsIncludedHeading;
